/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT REVIEW PAGE
 -----------------------------------------*/
let ReviewsTransitions = ( () => {

    let eventCatch = () => {
        $('.js-transfer').click( () => {
            return confirm('Вы уверены? Эту операцию невозможно отменить!\n Картинки отзыва буду удалены!');
        });
    };

    let init = () => {
        eventCatch();
    };

    return {
        init: init
    };

})();

export default ReviewsTransitions;
